<div class="terms-view full-height layout-row">

  <div class="terms-main layout-column flex">

    <div class="terms-toolbar layout-row layout-align-end-center">
      <bringoz-button *ngxPermissionsOnly="'term.terms.create'"
                      type="tertiary"
                      theme="secondary"
                      (onClick)="onCreate()">
        <div class="layout-row layout-align-center-center gap-5">
          <bringoz-icon iconName="plus" [classSize]="'sm'"></bringoz-icon>
          <span>{{ 'New Policy' | translate }}</span>
        </div>
      </bringoz-button>
    </div>

    <bz-table class="flex"
              [uniqueId]="tableUniqueId"
              [defaultWidths]="defaultWidths"
              [rowHeight]="rowHeight"
              [items]="versions"
              [isLoading]="isLoading"
              (fetchNext)="onFetchNext()">

      <ng-template bzTableHeader>
        <!-- col-name is pinned left and col-actions right by the column manager - renaming them unpins those columns. -->
        <div class="th col-name text-ellipsis">{{ 'Name' | translate }}</div>
        <div class="th col-version text-ellipsis">{{ 'Version' | translate }}</div>
        <div class="th col-status text-ellipsis">{{ 'Status' | translate }}</div>
        <div class="th col-created-at text-ellipsis">{{ 'Created At' | translate }}</div>
        <div class="th col-updated-at text-ellipsis">{{ 'Updated At' | translate }}</div>
        <div class="th col-published-at text-ellipsis">{{ 'Published At' | translate }}</div>
        <div class="th col-published-by text-ellipsis">{{ 'Published By' | translate }}</div>
        <div class="th col-actions"></div>
      </ng-template>

      <ng-template bzTableRow let-version>
        <div class="tr" [class.terms-row-archived]="version.status === statuses.Archived">

          <!-- Opens the version: editable while Draft, read-only once Published or Archived. -->
          <div class="td col-name text-ellipsis layout-row layout-align-start-center">
            <button type="button" class="terms-name-link text-ellipsis" (click)="onOpen(version)">{{ version.title }}</button>
          </div>

          <div class="td col-version layout-row layout-align-start-center">{{ version.versionNumber }}</div>

          <div class="td col-status layout-row layout-align-start-center">
            <bz-tag [tone]="statusTone[version.status]">{{ version.status | translate }}</bz-tag>
          </div>

          <div class="td col-created-at text-ellipsis layout-row layout-align-start-center">
            {{ version | bringozFullDate: 'createdAt' : '-' }}
          </div>

          <div class="td col-updated-at text-ellipsis layout-row layout-align-start-center">
            {{ version | bringozFullDate: 'updatedAt' : '-' }}
          </div>

          <div class="td col-published-at text-ellipsis layout-row layout-align-start-center">
            {{ version | bringozFullDate: 'publishedAt' : '-' }}
          </div>

          <div class="td col-published-by text-ellipsis layout-row layout-align-start-center">
            {{ version.publishedBy || '-' }}
          </div>

          <div class="td col-actions layout-row layout-align-end-center gap-5">
            @if (rowActions[version.status].approvals) {
              <bringoz-button *ngxPermissionsOnly="'term.terms.get'"
                              type="tertiary" size="fit"
                              (onClick)="onOpenApprovals()">
                <bringoz-icon iconName="team" [classSize]="'md'" [tooltip]="'Approved By Agent' | translate"></bringoz-icon>
              </bringoz-button>
            }
            @if (rowActions[version.status].archive) {
              <bringoz-button *ngxPermissionsOnly="'term.terms.update'"
                              type="tertiary" size="fit"
                              (onClick)="onArchive(version)">
                <bringoz-icon iconName="trash" [classSize]="'md'" [tooltip]="'Archive' | translate"></bringoz-icon>
              </bringoz-button>
            }
            <bringoz-button *ngxPermissionsOnly="'term.terms.create'"
                            type="tertiary" size="fit"
                            (onClick)="onDuplicate(version)">
              <bringoz-icon iconName="duplicate" [classSize]="'md'" [tooltip]="'Duplicate' | translate"></bringoz-icon>
            </bringoz-button>
            @if (rowActions[version.status].edit) {
              <bringoz-button *ngxPermissionsOnly="'term.terms.update'"
                              type="tertiary" size="fit"
                              (onClick)="onOpen(version)">
                <bringoz-icon iconName="edit-outline" [classSize]="'md'" [tooltip]="'Edit' | translate"></bringoz-icon>
              </bringoz-button>
            }
            @if (rowActions[version.status].publish) {
              <bringoz-button *ngxPermissionsOnly="'term.terms.update'"
                              theme="secondary" size="sm"
                              (onClick)="onPublish(version)">
                <div class="layout-row layout-align-center-center gap-5">
                  <bringoz-icon iconName="export" [classSize]="'sm'"></bringoz-icon>
                  <span>{{ 'Publish' | translate }}</span>
                </div>
              </bringoz-button>
            }
          </div>

        </div>
      </ng-template>

      <app-empty-state bzTableEmptyState
                       src="assets/images/empty_state/empty_state_location_box.svg"
                       text="No policies found">
      </app-empty-state>

    </bz-table>

  </div>

  @if (isApprovalsOpen) {
    <app-terms-approvals-panel (onClose)="onCloseApprovals()"></app-terms-approvals-panel>
  }

</div>
